import { ActivatedRoute } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';
import { IUsersService } from '@shared/interfaces/users-service.interface';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'authentication-fail',
  imports: [TranslateModule],
  templateUrl: './authentication-fail.component.html',
  styleUrl: './authentication-fail.component.scss'
})
export class AuthenticationFailComponent implements OnInit {

  public message: string | null = '';
  public errorCode: string | null = '';
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly userService: IUsersService = inject(IUsersService);
  private readonly translateService: TranslateService = inject(TranslateService);


  public ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.message = params.get('message');
      this.errorCode = params.get('errorCode');
    });
  }

  public goBackToLogin(): void {
    this.userService.signoutRedirect();
  }
  private get hasErrorCode(): boolean {
    return this.errorCode !== null && this.errorCode !== '';
  }
  public get errorMessage(): string {
    const errorKey = 'auth_failed_error';
    if (this.hasErrorCode) {
      return this.translateService.instant(`${errorKey}_${this.errorCode}`) + " (errorCode:" + this.errorCode + ")";
    }
    return this.translateService.instant(`auth_failed_error_unknow`) + " (errorCode:2100)";
  }
}
